import React, { Component, Fragment } from 'react';
import ApiService from "../../../ApiService";
import ISalamanderHostRunBlobFile from '../../../../models/hosted-salamander/IHostRunBlobFile';
import SchoolPageTitle from '../../../SchoolPageTitle';
import AdminSchoolMenu from '../../../AdminSchoolMenu';
import {MisDataServiceTypes} from "../../../../models/SchoolMailroomConfigDto";
import MisFetchRunFilesTable from "../../../mis-fetch/MisFetchRunFilesTable";
import MisFetchRunLogs from "../../../mis-fetch/MisFetchRunLogs";

interface MisFetchRunPageProps {
    apiService: ApiService;

    tenantId: string;
    schoolCode: string;
    dataServiceType: MisDataServiceTypes;
    id: string;
}

interface MisFetchRunPageState {
    files?: ISalamanderHostRunBlobFile[];
    logs?: string;
}

export default class MisFetchRunPage extends Component<MisFetchRunPageProps, MisFetchRunPageState> {
    static displayName = MisFetchRunPage.name;

    constructor(props: MisFetchRunPageProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount() {
  
        await this.loadFiles();
        await this.loadLogs();
    }

    async componentDidUpdate(prevProps: Readonly<MisFetchRunPageProps>, prevState: any): Promise<void> {

    }
    
    private loadFiles = async () => {
        
        this.setState({
            files:undefined
        });

        const files = await this.props.apiService.getSalamanderHostRunFiles(this.props.tenantId, this.props.schoolCode,this.props.dataServiceType, this.props.id);

        this.setState({
            files
        });
    }

    private loadLogs = async () => {
        this.setState({
            logs: undefined
        });

        const logs = await this.props.apiService.getMisFetchRunLogs(this.props.tenantId, this.props.schoolCode, this.props.id);

        this.setState({
            logs
        });
    }

    render() {
        
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Hosted Run" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <MisFetchRunFilesTable title={"Files for Host Run " + this.props.id} dataServiceType={this.props.dataServiceType} files={this.state.files} />
                <MisFetchRunLogs title={"Logs for Host Run " + this.props.id} logs={this.state.logs} />
            </Fragment>
        );
    }
}